module.exports = __webpack_public_path__ + "assets/img/pine grove 109m.23266fa7.jpg";